import { Button, Form, Input, Upload } from "antd";
import React from "react";
import { MessagesService } from "services/Messages";

export function FormComponent(props) {
  function ValidateFile(file) {
    const isLargeFile = file?.size && file?.size >= 5 * 1024 * 1024;
    if (isLargeFile) {
      throw new Error(
        `${file.name} - Размер изображения не должен превышать 5 МБ.`
      );
    }
  }
  const onChange = ({ newFileList, key }) => {
    ValidateFile(newFileList[0]);
    if (newFileList[0]?.status === "done") {
      MessagesService.success("Файл успешно загружен");
    }
    const obj = Object.create(null);
    obj[key] = newFileList;
    props.setFileList({ ...props.fileList, ...obj });
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  return (
    <Form name={"Category"} form={props.form} onFinish={props.onFinish}>
      {/* Name */}
      <Form.Item
        label="Название"
        name="name"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        rules={[
          {
            required: true,
            message: "Обязательное",
          },
        ]}
      >
        <Input placeholder="Название..." />
      </Form.Item>

      {/* photo */}
      <Form.Item
        label="Фото"
        name="photo"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        rules={[
          {
            required: true,
            message: "Обязательное",
          },
        ]}
      >
        <Upload
          accept="image/png, image/jpeg, image/svg, image/webp"
          listType="picture-card"
          fileList={props.fileList?.photo || []}
          onPreview={onPreview}
          showUploadList={true}
          customRequest={({ file, onSuccess }) => {
            onSuccess("ok");
          }}
          onChange={(e) =>
            onChange({
              newFileList: e.fileList,
              key: "photo",
            })
          }
          onRemove={() => {
            props.setFileList({ ...props.fileList, photo: [] });
          }}
        >
          {props.fileList?.photo?.length < 1 && "+ Загрузить"}
        </Upload>
      </Form.Item>

      <Form.Item className="flex justify-end mb-0">
        <Button
          type="primary"
          size="large"
          htmlType="submit"
          loading={props.btnLoading}
        >
          {props.type === "create" ? "Создать" : "Обновить"}
        </Button>
      </Form.Item>
    </Form>
  );
}
